import type FetchService from '@triptyk/ember-utils/services/fetch';
import type { FavoriteAdapter } from '../favorite';

const endpointName = 'favorites';

export class BackendAdapter implements FavoriteAdapter {
  public constructor(private readonly fetchService: FetchService) {}

  async set(...favorites: string[]): Promise<void> {
    await this.fetchService.request(`${endpointName}/`, {
      method: 'PUT',
      body: JSON.stringify({ favorites }),
    });
  }

  async add(favorite: string) {
    await this.fetchService.request(`${endpointName}/`, {
      method: 'POST',
      body: JSON.stringify({ favorite }),
    });
  }

  async getAll(): Promise<string[]> {
    const response = await this.fetchService
      .request(`${endpointName}/`, {
        method: 'GET',
      })
      .then((response) => response.json());
    return response.favorites;
  }

  async remove(favorite: string): Promise<void> {
    await this.fetchService.request(`${endpointName}/${favorite}`, {
      method: 'DELETE',
      body: JSON.stringify({ id: favorite }),
    });
  }

  async isFavorite(id: string): Promise<boolean> {
    const response = await this.fetchService
      .request(`${endpointName}/is-favorite/${id}`, {
        method: 'GET',
      })
      .then((response) => response.json());
    return response.isFavorite;
  }
}
